module.exports = "<p class=\"ta-c hidden-xs\">\n  &copy; {{currentYear}} Health Forum, LLC, an affiliate of the American Hospital Association\n</p>\n\n<p class=\"ta-c visible-xs\">\n  &copy; {{currentYear}} Health Forum, LLC, an affiliate of the <br> American Hospital Association\n</p>\n\n<p class=\"ta-c\">\n  <a href=\"http://www.aha.org/help/termsofuse.shtml\" target=\"_blank\" class=\"p-5\">Terms of Use</a>\n  |\n  <a href=\"http://www.aha.org/help/privacy.shtml\" target=\"_blank\" class=\"p-5\">Privacy Policy</a>\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/footer/footer.component.html
// module id = ./src/app/footer/footer.component.html
// module chunks = main